var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBin2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2904 5.5H3.70703",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7622 7.79297L17.3405 14.1172C17.1783 16.5508 17.0972 17.7677 16.3042 18.5095C15.5113 19.2513 14.2918 19.2513 11.8527 19.2513H11.1438C8.70474 19.2513 7.4852 19.2513 6.69228 18.5095C5.89935 17.7677 5.81823 16.5508 5.65599 14.1172L5.23438 7.79297",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45703 5.5C6.50825 5.5 6.53387 5.5 6.55708 5.49941C7.31191 5.48028 7.9778 5.00033 8.23465 4.29029C8.24255 4.26845 8.25065 4.24415 8.26684 4.19556L8.35584 3.92857C8.43181 3.70066 8.4698 3.58669 8.52019 3.48993C8.72121 3.1039 9.09313 2.83583 9.52292 2.7672C9.63065 2.75 9.75077 2.75 9.99102 2.75H13.0064C13.2466 2.75 13.3667 2.75 13.4745 2.7672C13.9043 2.83583 14.2762 3.1039 14.4772 3.48993C14.5276 3.58669 14.5656 3.70065 14.6416 3.92857L14.7306 4.19556C14.7467 4.24409 14.7549 4.26847 14.7627 4.29029C15.0196 5.00033 15.6855 5.48028 16.4403 5.49941C16.4635 5.5 16.4891 5.5 16.5404 5.5",
    stroke: "#DC3545",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin2);
export default __webpack_public_path__ + "static/media/TrashBin2.696a4e4493bb8d4aa6c89d71413b8e57.svg";
export { ForwardRef as ReactComponent };